import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import locales from 'locales';
import {store} from "../store";



const Translate = ({ user, text }) => (
  <Fragment>
    {locales[user.language][text]}
  </Fragment>
);

Translate.propTypes = {
  user: PropTypes.object,
  text: PropTypes.string,
};

const mapSateToProps = state => ({
  user: state.user,
});

export const t = ({ user, text }) => {
  return locales[user.language][text]
};

export default connect(mapSateToProps)(Translate);


// WEBPACK FOOTER //
// ./src/components/Translate.jsx